module.exports = __webpack_public_path__ + "static/media/crown.c299a0e4.png";